export default __webpack_public_path__ + "static/media/pdt.94ef5f91.png";